export default __webpack_public_path__ + "static/media/main-logo.1b46bc56.png";